import { render, staticRenderFns } from "./count2.vue?vue&type=template&id=72291189&scoped=true&"
import script from "./count2.vue?vue&type=script&lang=js&"
export * from "./count2.vue?vue&type=script&lang=js&"
import style0 from "./count2.vue?vue&type=style&index=0&id=72291189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72291189",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72291189')) {
      api.createRecord('72291189', component.options)
    } else {
      api.reload('72291189', component.options)
    }
    module.hot.accept("./count2.vue?vue&type=template&id=72291189&scoped=true&", function () {
      api.rerender('72291189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/visit/count2.vue"
export default component.exports